import React from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle } from 'lucide-react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from 'shared/components/ui/Accordion';
import './FAQSection.scss';

const FAQSection = () => {
  const { t } = useTranslation();

  const faqs = [
    {
      question: t('faq_what_is_likiee_q', 'What is Likiee?'),
      answer: t(
        'faq_what_is_likiee_a',
        'Likiee is an AI-powered visual search engine and shopping assistant that helps you discover, compare, and organize fashion items. From virtual try-on to price tracking, Likiee makes smart shopping simple.',
      ),
    },
    {
      question: t('faq_how_virtual_tryon_q', 'How does virtual try-on work?'),
      answer: t(
        'faq_how_virtual_tryon_a',
        'Upload your photo and select any fashion item from your saved Likiee products or upload any image. Our AI technology instantly shows how the item would look on you, helping you make confident purchase decisions.',
      ),
    },
    {
      question: t('faq_is_free_q', 'Is Likiee free to use?'),
      answer: t(
        'faq_is_free_a',
        'Yes! Likiee offers a free plan with access to core features including visual search, wishlists, and browser extension. Premium plans unlock advanced features like unlimited AI comparisons and priority support.',
      ),
    },
    {
      question: t('faq_which_stores_q', 'Which online stores does Likiee work with?'),
      answer: t(
        'faq_which_stores_a',
        'Likiee works with thousands of online retailers worldwide. Our browser extension allows you to save items from any website, and our AI helps you find similar products and better deals across all supported stores.',
      ),
    },
    {
      question: t('faq_price_tracking_q', 'How does price tracking work?'),
      answer: t(
        'faq_price_tracking_a',
        "When you save items to your Likiee list, we automatically monitor prices across multiple retailers. You'll receive notifications when prices drop or when better deals become available.",
      ),
    },
    {
      question: t('faq_shared_wishlists_q', 'Can I share my wishlists with friends?'),
      answer: t(
        'faq_shared_wishlists_a',
        'Absolutely! Create shared wishlists that friends and family can view and contribute to. Perfect for gift-giving occasions, wedding registries, or planning group purchases.',
      ),
    },
  ];

  return (
    <section id='faq' className='faq-section'>
      <div className='faq-section__container'>
        <header className='faq-section__header'>
          <div className='faq-section__badge'>
            <HelpCircle size={16} aria-hidden='true' />
            <span className='faq-section__badge-text'>{t('faq_badge', 'FAQ')}</span>
          </div>
          <h2 className='faq-section__title'>
            {t('faq_title_line1', 'Frequently Asked')}{' '}
            <span className='faq-section__title--gradient'>{t('faq_title_line2', 'Questions')}</span>
          </h2>
          <p className='faq-section__subtitle'>{t('faq_subtitle', 'Everything you need to know about Likiee')}</p>
        </header>

        <div className='faq-section__content'>
          <Accordion type='single' collapsible className='faq-section__accordion'>
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger>{faq.question}</AccordionTrigger>
                <AccordionContent>{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
